module.exports = __webpack_public_path__ + "static/img/logo12.4b59528f.png";